import { useContext, useEffect } from 'react';
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer';
import * as Cesium from 'cesium';
import CesiumNavigation from '@znemz/cesium-navigation';

export default function Compass() {
    const viewer = useContext(CesiumViewerContext)
    useEffect(() => {
        if (!viewer) {
            return;
        }
        let options = {
            defaultResetView: Cesium.Rectangle.fromDegrees(100, -60, 160, 0),
            enableDistanceLegend: true,
            enableCompassOuterRing: true,
            enableZoomControls: true,
            enableCompass: true
        };
        CesiumNavigation((viewer as any),options);
    }, [viewer])

    return null
}
